(function (factory) {
    typeof define === 'function' && define.amd ? define(factory) :
    factory();
})((function () { 'use strict';

    /**
     * Slider setup. Using Cycle2 jQuery plugin.
     *
     * @see http://jquery.malsup.com/cycle2/api/
     */
    jQuery(function($){
        // disable cycle log messages
        $.fn.cycle.log = $.noop;
        $( '.mini-gallery' ).on( 'cycle-before', function(event, optionHash, outgoingSlideEl, incomingSlideEl, forwardFlag) {
            var percent = (((optionHash.slideNum-1) / (optionHash.slideCount-1)) * 100)/2;
            $('.mini-gallery__position-indicator', this).css('left', percent + '%' );
        });
    });

}));
